// 待辦指示器 — header 右上角。2026-07-07 user spec:
//   「把左邊『我的待辦』選單拿掉、完全收進鈴鐺; 紅色數字常駐; 點鈴鐺直接跳
//    整頁、不要下拉」
//
// 所以這顆從「dropdown 通知中心」簡化成「常駐待辦數字 + 點擊 → /approvals?tab=inbox (待我簽核)」。
// 數字 = useTodoCount().total (待我處理 workflow + 待我簽核 approval + 我發起被
// 退回)。
// ⚠ 2026-08-03: 這句原本寫「跟簽核中心『待我簽核』清單口徑一致」—— **當時不成立**：
// total 含「我發起被退回」，而那一格在 inbox tab 完全沒有顯示 → 使用者看到「待辦 1」
// 點進去卻是空的（實際踩到）。 已在 ApprovalsPage 的 inbox tab 補上「↩ 被退回 ·
// 需要我處理」區塊，現在才真的一致。 改動任一邊都要同時顧另一邊。
// dropdown 內原本的 inline 核准 / 夥伴一鍵核可移到整頁 (WorkflowDetailDrawer) 與 /parties。
import { Link } from 'react-router-dom';
import { useTodoCount } from '../lib/use-todo-count.ts';

export function WorkflowBell() {
  const todo = useTodoCount();
  const n = todo.total;
  const has = n > 0;
  return (
    <Link
      to="/approvals?tab=inbox"
      title={`我的待辦 — ${n} 件待處理`}
      aria-label={`我的待辦，${n} 件待處理`}
      className="flex items-center gap-1.5 h-9 pl-2 pr-1.5 rounded hover:bg-slate-800 transition-colors"
    >
      <span className="text-base leading-none">🔔</span>
      <span className="text-sm hidden sm:inline text-slate-200">待辦</span>
      <span
        className={`min-w-[20px] h-5 px-1.5 rounded-full text-[11px] font-bold leading-5 text-center ${
          has ? 'bg-red-500 text-white' : 'bg-slate-700 text-slate-400'
        }`}
      >
        {n > 99 ? '99+' : n}
      </span>
    </Link>
  );
}
